import React from "react";
import { Route, Routes } from "react-router-dom";
import SignIn from "../Authentication/signIn";
import SignUp from "../Authentication/OnBoarding";
import DashboardLayout from "../Dashboard";
import SuccessPage from "../../components/SuccessPage";
// import StripeCheckoutForm from "../PaymentGateway/StripeCheckout";


export default function NavRoutes() {
  return (
    <>
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/auth/signin" element={<SignIn />} />
        <Route path="/auth/signup" element={<SignUp />} />
        <Route path="dashboard/*" element={<DashboardLayout />} />
        <Route path="/auth/verify/:id/:code" element={<SuccessPage />} />
        {/* <Route path="/dashboard/checkout" element={<StripeCheckoutForm/>}/> */}
      </Routes>
    </>
  );
}
